<template>

    <form ref="estagioavaliacao-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-8">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" maxlength="100" name="nome" placeholder="Nome" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-4">
                <label for="unidade">Unidade</label>
                <input type="text" class="form-control" name="unidade" maxlength="20" placeholder="Unidade" v-model="model.unidade" />
            </div>
            <div class="form-group col-md-12">
                <label for="nomeTraduzido">Nome Traduzido</label>
                <input type="text" class="form-control" maxlength="150" name="nome" placeholder="Nome Traduzido" v-model="model.nomeTraduzido" required />
            </div>
            <div class="form-group col-md-4">
                <label for="tipoAvaliacaoId">Tipo de Avaliação</label>
                <select v-select="{ dataitem: 'TipoAvaliacao', default: 'Selecione' }" v-model="model.tipoAvaliacaoId" class="form-control" name="tipoAvaliacaoId" required></select>
            </div>
            <div class="form-group col-md-4">
                <label for="ordem">Ordem</label>
                <input type="number" class="form-control" min="0" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">Pontuação</label>
                <input type="text" class="form-control" name="pontuacao" placeholder="Pontuação" v-model="model.pontuacao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">External ID</label>
                <input type="number" class="form-control" name="externalId" placeholder="External ID" v-model="model.externalId" required />
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ignoraPontuacaoPadrao" class="custom-control-input" v-model="model.ignoraPontuacaoPadrao">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Lança nota de 0 a 10?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="meioCurso" class="custom-control-input" v-model="model.meioCurso">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Meio de Curso?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="salaAula" class="custom-control-input" v-model="model.salaAula">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Sala de Aula?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="excluido" class="custom-control-input" v-model="model.excluido">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Excluído?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <label class="custom-control" style="padding-left: 0px">Anexar Prova</label>
                <input id="arquivoProva" name="arquivoProva" style="padding-left: 15px; width: 100%" type="file" @change="handleSelectedTestFile" accept="application/pdf" />
                <small class="pull-right">Somente arquivos em PDF</small>
            </div>
            <div class="form-group col-md-12">
                <label class="custom-control" style="padding-left: 0px">Anexar Gabarito</label>
                <input id="arquivoGabaritoProva" name="arquivoGabaritoProva" style="padding-left: 15px; width: 100%" type="file" @change="handleSelectedAnswerKeyFile" accept="application/pdf" />
                <small class="pull-right">Somente arquivos em PDF</small>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioavaliacao-form-create",
        mixins: [base],
        props: { estagioId: Number },
        data: () => ({

            model: {
                tipoAvaliacaoId: ""
            },

            form: "estagioavaliacao-form-create",

            resources: {
                create: 'estagioavaliacao/salvaravaliacaocomarquivos',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;
                this.model.estagioId = this.estagioId;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso.');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            handleSelectedTestFile(event) {
                if (event.target.files && event.target.files[0]) {
                    var file = event.target.files[0];

                    if (!file)
                        return false;

                    if (file.type != "application/pdf") {
                        this.defaultErrorResult("O arquivo de prova selecionado não está em formato PDF. Por favor, revise.");
                        document.getElementById("arquivoProva").value = "";
                        return false;
                    }

                    var reader = new FileReader();
                    reader.readAsBinaryString(file);

                    reader.onload = () => {
                        this.model.arquivoProvaBase64 = btoa(reader.result);
                        this.model.nomeArquivoProvaOriginal = file.name;
                    };
                }
            },

            handleSelectedAnswerKeyFile(event) {
                if (event.target.files && event.target.files[0]) {
                    var file = event.target.files[0];

                    if (!file)
                        return false;

                    if (file.type != "application/pdf") {
                        this.defaultErrorResult("O arquivo de gabarito selecionado não está em formato PDF. Por favor, revise.");
                        document.getElementById("arquivoGabaritoProva").value = "";
                        return false;
                    }

                    var reader = new FileReader();
                    reader.readAsBinaryString(file);

                    reader.onload = () => {
                        this.model.arquivoGabaritoProvaBase64 = btoa(reader.result);
                        this.model.nomeArquivoGabaritoProvaOriginal = file.name;
                    };
                }
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

